module.exports = "/_next/static/images/9cb45a509ef5e77ca11f9daa95792dc8-icon-app.svg";